import { ActionType } from "@sp-crm/core";
import { ContentContainer } from "components/layout";
import { SubnavMenu, SubnavMenuItem } from "components/navigation/subnav";
import React from "react";
import {
    useIsAllowed,
    useIsAllowedInWholeTenant,
    useIsMultiRegionUser,
} from "store/selectors/hooks";

export const SettingsNavigation: React.FC<unknown> = () => {
    const isMultiRegionUser = useIsMultiRegionUser();
    const editAgencySettingsAllowed = useIsAllowedInWholeTenant(ActionType.UpdateTenant);
    const editRegionSettingsAllowed = useIsAllowed(ActionType.UpdateRegionSettings);
    const manageUsersAllowed = useIsAllowed(ActionType.SelfManageModifyUser);
    const manageIntegrationsAllowed = useIsAllowedInWholeTenant(
        ActionType.ManageIntegrations,
    );
    const csvDownloadEnabled = useIsAllowed(ActionType.ExportCsv);

    const manageWorkflowsAllowed = useIsAllowed(ActionType.CreateWorkflow);

    const showAgencySettings = editAgencySettingsAllowed;
    const showRegionSettings =
        (editRegionSettingsAllowed && isMultiRegionUser) ||
        (editRegionSettingsAllowed && !editAgencySettingsAllowed);

    return (
        <ContentContainer className="mb-4">
            <SubnavMenu>
                <SubnavMenuItem to="/settings/account">My settings</SubnavMenuItem>
                <SubnavMenuItem to="/settings/templates">
                    Email Templates & Signatures
                </SubnavMenuItem>
                {showAgencySettings ? (
                    <SubnavMenuItem to="/settings/agency">Agency settings</SubnavMenuItem>
                ) : null}
                {showRegionSettings ? (
                    <SubnavMenuItem to="/settings/region">Office settings</SubnavMenuItem>
                ) : null}
                {manageWorkflowsAllowed ? (
                    <SubnavMenuItem to="/settings/workflow">Workflows</SubnavMenuItem>
                ) : null}
                {manageUsersAllowed ? (
                    <SubnavMenuItem to="/settings/users">User accounts</SubnavMenuItem>
                ) : null}
                {manageIntegrationsAllowed ? (
                    <SubnavMenuItem to="/settings/integrations">
                        Integrations
                    </SubnavMenuItem>
                ) : null}
                {csvDownloadEnabled ? (
                    <SubnavMenuItem to="/settings/exports">CSV Exports</SubnavMenuItem>
                ) : null}
            </SubnavMenu>
        </ContentContainer>
    );
};
